(function () {

  var _advancedCartPence = null;

  function init() {
    // Injection already done by inline script in theme.liquid.
    // This deferred script only needs to bind the click events.

    // Seed from the Liquid-rendered value so VAT toggle works on all pages,
    // not just the basket page where btk:cart:total:updated fires.
    

    var btnInc = document.getElementById('btk-vat-inc');
    var btnExc = document.getElementById('btk-vat-exc');

    

    // Sync UI on load and whenever toggle fires from anywhere else
    syncUI();
    document.addEventListener('btk:vat:changed', syncUI);

    // Update header cart total whenever the advanced cart recalculates
    document.addEventListener('btk:cart:total:updated', function(e) {
      var cartTotal = document.getElementById('header-cart-total');
      if (!cartTotal || !window.BTKVat) return;
      var pence = e.detail && e.detail.pence;
      if (typeof pence === 'number') {
        _advancedCartPence = pence;
        cartTotal.setAttribute('data-btk-raw', pence);
        cartTotal.textContent = window.BTKVat.formatPrice(pence);
        cartTotal.style.display = '';
      }
    });
  }

  function syncUI() {
    var track  = document.getElementById('btk-header-vat-track');
    var btnInc = document.getElementById('btk-vat-inc');
    var btnExc = document.getElementById('btk-vat-exc');
    if (!track || !window.BTKVat) return;
    var inc = window.BTKVat.isIncVat();
    track.classList.toggle('is-right', !inc);
    if (btnInc) btnInc.classList.toggle('is-active', inc);
    if (btnExc) btnExc.classList.toggle('is-active', !inc);

    var cartTotal = document.getElementById('header-cart-total');
    if (cartTotal && window.BTKVat) {
      var raw = _advancedCartPence !== null
        ? _advancedCartPence
        : parseInt(cartTotal.getAttribute('data-btk-raw'), 10);
      if (!isNaN(raw)) {
        cartTotal.setAttribute('data-btk-raw', raw);
        cartTotal.textContent = window.BTKVat.formatPrice(raw);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();